export default __webpack_public_path__ + "static/estrutura-2-eee5ce6f36e95bbca2babd4c33ada29c.png";